/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Pagination } from "../../component/Pagination";

const MyAdminComponent = ({
  page,
  count,
  admins,
  setPage,
  setTotal,
  pageSize,
  setPageSize,
  currentYear,
  currentMonth,
  currentAdmin,
  loadStatistics,
  setCurrentAdmin,
  setLocalSetStats,
  getAllByAdminCompanyId,
}) => {
  // visual-only helpers
  const getInitials = (a = "", b = "") => {
    const fi = (a || "").trim().charAt(0).toUpperCase();
    const li = (b || "").trim().charAt(0).toUpperCase();
    return (fi + li) || "A";
  };

  const palettes = [
    { grad: "from-emerald-500 to-teal-500" },
    { grad: "from-indigo-500 to-purple-500" },
    { grad: "from-amber-500 to-red-500" },
    { grad: "from-sky-500 to-indigo-500" },
    { grad: "from-fuchsia-500 to-rose-500" },
    { grad: "from-lime-500 to-emerald-500" },
  ];

  return (
    <div className="flex flex-col justify-between gap-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-sm md:text-base font-semibold text-gray-900">My Admins</h3>
        <span className="text-[11px] text-gray-500">
          {typeof count === "number" ? `Total: ${count}` : `Showing ${admins?.length || 0}`}
        </span>
      </div>

      {/* List */}
      <div className="flex flex-col gap-2 max-h-[420px] overflow-y-auto pr-1">
        {admins ? (
          admins.map((adm, idx) => {
            const selected = idx === currentAdmin;
            const tone = palettes[idx % palettes.length];

            return (
              <div
                key={idx}
                role="button"
                // aria-selected={selected}
                onClick={() => {
                  setCurrentAdmin(idx);
                  setLocalSetStats(null);
                  setTotal(0);
                  loadStatistics({
                    year: currentYear,
                    month: currentMonth,
                    admin: adm?.admin_id,
                  });
                }}
                className={[
                  "group flex items-center justify-between gap-3 rounded-xl px-3 py-2 cursor-pointer transition",
                  "border border-gray-200 bg-white hover:bg-gray-50 hover:ring-1 hover:ring-gray-300",
                  selected
                    ? "!bg-gray-900 !text-white !border-gray-900 hover:!bg-gray-900 hover:!text-white hover:!ring-0"
                    : "!text-gray-800",
                ].join(" ")}
              >
                {/* Left: Avatar + name */}
                <div className="flex items-center gap-3 min-w-0">
                  <div
                    className={[
                      "h-9 w-9 shrink-0 rounded-full text-white text-xs font-semibold",
                      "flex items-center justify-center shadow-sm ring-1 ring-black/5",
                      `bg-gradient-to-br ${tone.grad}`,
                    ].join(" ")}
                    aria-hidden
                  >
                    {getInitials(adm?.first_name, adm?.last_name)}
                  </div>
                  <div className="min-w-0">
                    <p className={`font-medium text-sm truncate ${selected ? "text-white bg-gray-900" : "text-gray-900"}`}>
                      {`${String(adm?.first_name || "")} ${String(adm?.last_name || "")}`}
                    </p>
                    <p className={`text-[11px] truncate ${selected ? "text-white/80 bg-gray-900" : "text-gray-500"}`}>
                      Click to load monthly stats
                    </p>
                  </div>
                </div>

                {/* Right: status bead */}
                <span
                  className={[
                    "h-2 w-2 rounded-full",
                    selected ? "bg-white" : `bg-gradient-to-br ${tone.grad}`,
                  ].join(" ")}
                />
              </div>
            );
          })
        ) : (
          // Skeletons (visual only)
          Array.from({ length: 6 }).map((_, i) => (
            <div
              key={`sk-${i}`}
              className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2 animate-pulse"
            >
              <div className="h-9 w-9 rounded-full bg-gray-200" />
              <div className="flex-1">
                <div className="h-3 w-40 bg-gray-200 rounded mb-1" />
                <div className="h-2.5 w-28 bg-gray-100 rounded" />
              </div>
              <div className="h-2 w-2 rounded-full bg-gray-200" />
            </div>
          ))
        )}
      </div>

      {/* Pagination (kept as-is, just spacing) */}
      <div className="pt-1">
        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={count}
          callbackFunction={(p, size) => {
            getAllByAdminCompanyId(p, size);
          }}
        />
      </div>
    </div>
  );
};

export default MyAdminComponent;
